import { add_many } from 'JIX/gettext.js';

const JIX = window.JIX = window.JIX || {};

JIX.Gettext = { add_many };
